import React, { useState } from "react";
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux'
import { useFirestore, useFirebase, isEmpty, isLoaded } from 'react-redux-firebase';
import { v4 as uuidv4 } from 'uuid';
import { Wizard, Pages, Page, useWizardContext } from '../../components/Wizard';
import { useBodyClass } from '../../hooks'
import { Link } from 'react-router-dom';

const urlRegex = /(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;
const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

// FIXME: Don't set classes in the body

const StepContentType = () => {
  const { register } = useFormContext()

  return (
    <>
    <StepTitle>
      How do you want<br/> submit your content?
    </StepTitle>
    <div className="row no-gutters">
      <div className="col-6">
        <input 
          type="radio"
          style={{display: "none"}}
          value="url"
          name="contentType"
          id="contentTypeUrl"
          ref={register({required: true})} />
        <label
          style={{display: "block"}}
          className="choice choice-1 mb-0"
          htmlFor="contentTypeUrl"
        >
          <h3 className="mt-2 mb-3">Add URL</h3>
          <i className="fas fa-globe"></i>
        </label>
      </div>
      <div className="col-6">
        <input
          type="radio"
          style={{display: "none"}}
          value="file"
          name="contentType"
          id="contentTypeFile"
          ref={register({required: true})} />
        <label
          style={{display: "block"}}
          className="choice choice-2 mb-0"
          htmlFor="contentTypeFile"
        >
          <h3 className="mt-2 mb-3">Upload file</h3>
          <i className="far fa-file-alt"></i>
        </label>
      </div>
    </div>
    </>
  );
}


const FromUrl = () => {
  const { register } = useFormContext();
  return (
    <>
      <i class="fas fa-globe"></i>
      <StepTitle>
        Add URL
      </StepTitle>
      <p className="pb-3">Your blog post, Medium story <br />or online document</p>
      <div className="text-left">
        <label htmlFor="contentUrl">Content URL*</label>
        <input type="text" id="contentUrl" name="contentUrl" className="form-control" ref={register({required: true, pattern: urlRegex})}/>
      </div>
    </>
  );
}

const FromFile = () => {
  const { register, watch } = useFormContext();
  const file = watch("file");

  return (
    <>
      <i class="far fa-file-alt"></i>
      <StepTitle>
        Upload file
      </StepTitle>
      <p className="pb-3">Your Word document,<br /> .txt or .PDF file</p>
      <div className="input-group">
        <div className="custom-group text-left">
          <input type="file" name="file" className="custom-file-input" id="contentFile" ref={register({required: true})}/>
          <label className="custom-file-label" htmlFor="contentFile">
            {(file && file.length > 0) ? (
              <>{file[0].name}</>
            ) : (
              <>Choose file <small className="text-muted">(Max 10mb)</small></>
            )}
          </label>
        </div>
      </div>
    </>
  );
}

const StepContentUpload = () => {
  const { formData: { contentType } } = useWizardContext();
  return contentType === "file" ? <FromFile /> : <FromUrl />;
}

const StepContentEditing = () => {
  const { register } = useFormContext()

  return (
    <>
      <StepTitle>
        Should we edit your content?
      </StepTitle>
      <div className="row no-gutters">
        <div className="col-6">
          <input 
            type="radio"
            style={{display: "none"}}
            value="yes"
            name="edit"
            id="editYes"
            ref={register({required: true})} />
          <label style={{display: "block"}} className="choice choice-1 mb-0" htmlFor="editYes">
            <h3 className="mt-2 mb-3">Yes, please</h3>
            <i className="fas fa-edit"></i>
          </label>
        </div>
        <div className="col-6">
          <input
            type="radio"
            style={{display: "none"}}
            value="no"
            name="edit"
            id="editNo"
            ref={register({required: true})} />
          <label style={{display: "block"}} className="choice choice-2 mb-0" htmlFor="editNo">
            <h3 className="mt-2 mb-3">No, thanks</h3>
            <i className="far fa-file-alt"></i>
          </label>
        </div>
      </div>
    </>
  );
}

const StepDetails = ( { isAuthenticated = false } ) => {
  const { register } = useFormContext()

  return (
    <>
      <StepTitle>
        Podcast details
      </StepTitle>
      <div className="row no-gutters sex">
        <div className="col-6">
          <input
            type="radio"
            style={{display: "none"}}
            value="female"
            name="voice"
            id="voiceFemale"
            ref={register({required: true})} />
          <label style={{display: "block"}} className="choice choice-1 mb-0" htmlFor="voiceFemale">
            <h3 className="mt-2 mb-3">Female voice</h3>
            <i class="far fa-user-circle female"></i>
          </label>
        </div>
        <div className="col-6">
          <input
            type="radio"
            style={{display: "none"}}
            value="male"
            name="voice"
            id="voiceMale"
            ref={register({required: true})} />
          <label style={{display: "block"}} className="choice choice-2 mb-0" htmlFor="voiceMale">
            <h3 className="mt-2 mb-3">Male voice</h3>
            <i class="far fa-user-circle male"></i>
          </label>
        </div>
      </div>
      { isAuthenticated ? (
        <div className="text-left">
          <div class="form-group">
            <legend class="col-form-label">Edit your content*</legend>
            <select class="custom-select" name="contentEdit" ref={register({required: true, minLength: 1})}>
              <option value="">Please select</option>
              <option value="yes">Yes, edit before narrating</option>
              <option value="no">No, only narrate</option>
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="title">Podcast title <small class="text-muted">(optional)</small></label>
            <input type="text" id="title" name="title" className="form-control" ref={register()} />
          </div>
          <div className="form-group mb-0">
            <label htmlFor="notes">Notes <small class="text-muted">(optional)</small></label>
            <textarea class="form-control" id="notes" name="notes" ref={register()} rows="2"></textarea>
          </div>
        </div>
      ) : (
        <div className="text-left">
          <div className="form-group">
            <label htmlFor="email">Name</label>
            <input type="text" id="name" name="name" className="form-control" ref={register({required: true})} />
          </div>
          <div className="form-group mb-0">
            <label htmlFor="email">Email</label>
            <input type="email" id="email" name="email" className="form-control" ref={register({required: true, pattern: emailRegex})} />
          </div>
        </div>
      )}
    </>
  );
}

const StepSuccess = ({ submissionId, isAuthenticated, editing }) => (
  <StepContainer>
    <StepCard>
      <StepCardChoices>
        <i class="fas fa-microphone"></i>
        <StepTitle>Thanks, we've<br />got your submission!</StepTitle>
        <p class="mb-3">
          We'll update you within 24 hours 
        </p>
      </StepCardChoices>
      <div class="step-footer pl-3 pr-3 pb-3">
        <a href="/submit" class="btn btn-block btn-primary">
        Submit more content
        </a>
      </div>
    </StepCard>

    <div class="next-steps text-left mt-3 pt-3">
      { editing ? (
        <p class="in-progress">
          Next steps - We're editing your content &amp; we'll keep you posted.
        </p>
      ) : (
        <p class="in-progress">
          Next steps - We're narrating your podcast &amp; we'll keep you posted.
        </p>
      )}
    </div>
    <p class="pt-3">
      <Link to={`/podcasts/details/${submissionId}`}>
        View your submission <i class="fas fa-long-arrow-alt-right"></i>
      </Link>
    </p>

  </StepContainer>
)

const StepLoading = () => (
  <StepContainer>
    <div className="nothing-to-show text-center">
      <h2 className="h3">Loading...</h2>
      <p className="lead">
        Just a moment &amp; we'll be ready
      </p>
      <div className="loader">
        <div className="spinner-border text-primary" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </StepContainer>
)

const StepContainer = ({children}) => (
  <div className="row justify-content-center text-center">
    <div className="col-12 col-md-7 col-lg-5 col-xl-4 mt-5">
      {children}
    </div>
  </div>
);

const StepCard = ({children}) => (
  <div className="card p-0 mt-5">
    {children}
  </div>
);

const StepTitle = ({children}) => (
  <h2 className="mt-3 mb-3">{children}</h2>
);

const StepCardChoices = ({children}) => (
  <div className="step">
    <div className="step-choices p-3">
      { children }
    </div>
  </div>
);

const StepNextButton = () => {
  const { isLastPage } = useWizardContext();
  const { formState } = useFormContext()

  return (
    <div className="step-footer pl-3 pr-3 pb-3">
      <input
        type="submit"
        disabled={!formState.isValid}
        className={`btn btn-block btn-primary btn-block float-right ${ !formState.isValid && "disabled" }`}
        value={isLastPage ? "Submit your content" : "Next"}
        />
    </div>
  )
}

const StepCount = () => {
  const { activePage, pageTotal, previousPage } = useWizardContext();
  return (
    <div className="step-count pt-5 pb-3">
      { activePage > 0 && (
        <span href="#" onClick={previousPage} className="back" style={{}}>
          <i className="fas fa-long-arrow-alt-left"></i>
          &nbsp;
          Previous step
        </span>
      )}
      Step {activePage + 1} of {pageTotal}
    </div>
  )
}

const Offer = () => (
  <div className="offer text-center push">
    <i className="fas fa-gift"></i>
    Get 500 words for free <br />
    with your first podcast
  </div>
);

const StepPageContentTypeTryout = () => (
  <Page>
      <Offer />
      <StepCard>
        <StepCardChoices>
          <StepContentType />
        </StepCardChoices>
        <StepNextButton />
      </StepCard>
      <StepCount />
      <p className="text-muted">
        Simply submit your content <br />& choose your narrator's voice. 
        <span className="break mt-3">No credit card required.</span>
      </p>
  </Page>
);

const StepPageContentTypeAuthenticated = () => (
  <Page>
      <StepCard>
        <StepCardChoices>
          <StepContentType />
        </StepCardChoices>
        <StepNextButton />
      </StepCard>
      <StepCount />
      <p className="text-muted">
        For more information about pricing, <br/>
        see our <a href="https://www.narratedbypoise.com/pricing" target="blank">pricing page <i class="fas fa-long-arrow-alt-right"></i></a>
      </p>
  </Page>
);

const StepPageContentUpload = () => (
  <Page>
      <StepCard>
        <StepCardChoices>
          <StepContentUpload />
        </StepCardChoices>
        <StepNextButton />
      </StepCard>
      <StepCount />
  </Page>
)

const StepPageContentEditing = () => ( // eslint-disable-line no-unused-vars
  <Page>
      <StepCard>
        <StepCardChoices>
          <StepContentEditing />
        </StepCardChoices>
        <StepNextButton />
      </StepCard>
      <StepCount />
  </Page>
)

const StepPageDetails = ( { isAuthenticated = true } ) => (
  <Page>
      <StepCard>
        <StepCardChoices>
          <StepDetails isAuthenticated={isAuthenticated} />
        </StepCardChoices>
        <StepNextButton />
      </StepCard>
      <StepCount />
  </Page>
)

const TryOutHeader = () => {
  useBodyClass("try-out");

  return (
    <>
      <a href="https://narratedbypoise.com" className="logo">Poise</a>
      <a href="https://narratedbypoise.com" className="back back-home">
        <i className="fas fa-long-arrow-alt-left"></i>
        &nbsp;
        Back home
      </a>
    </>
  )
}
const DefaultHeader = () => (
  <>
    <a href="/" className="logo">Poise</a>
    <a href="/" className="close close-submit">
      <i className="fas fa-times"></i>
    </a>
  </>
)

const ContentSubmission = () => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [submission, setSubmission] = useState({});
  const auth = useSelector(state => state.firebase.auth)
  const firestore = useFirestore();
  const firebase = useFirebase();
  const isAuthenticated = !isEmpty(auth);

  const onSubmit = async ({ formData, formContext, wizardContext }) => {
    setLoading(true);

    // Get submission & file
    const submission = { ...formData };
    const file = submission.file && submission.file.length === 1 && submission.file[0];
    delete submission.file;

    // Generate an id
    const id = uuidv4();

    // Upload file
    if (file) {
      const fileRef = firebase.storage().ref().child('submissions').child(id);
      const fileSnapshot = await fileRef.put(file);
      submission.contentFileUrl = await fileSnapshot.ref.getDownloadURL();
    }

    // Populate auth details
    if (!isEmpty(auth)) {
      submission['userId'] = auth.uid;
      submission['email'] = auth.email;
    }

    // Add submission to firestore
    await firestore.collection('submissions').doc(id).set(submission);

    setSubmission({
      ...submission,
      id
    });
    setLoading(false);
    setSuccess(true);
  }

  if (!isLoaded(auth)) {
    return <></>
  }

  return (
    <div className="tryout">
      <div className="container">
        { !isAuthenticated ? <TryOutHeader /> : <DefaultHeader /> }
        { !success && !loading && (
          <StepContainer>
          <Wizard formArgs={{mode: "onChange"}} onSubmit={onSubmit}>
            <Pages>
              { isAuthenticated ? <StepPageContentTypeAuthenticated /> : <StepPageContentTypeTryout /> }
              <StepPageContentUpload />
              <StepPageDetails isAuthenticated={isAuthenticated} />
            </Pages>
          </Wizard>
          </StepContainer>
        )}
        { !success && loading && (
          <StepLoading />
        )}
        { success && !loading && (
          <StepSuccess
            submissionId={submission.id}
            isAuthenticated={isAuthenticated}
            editing={submission.contentEdit === "yes"}
            />
        )}
      </div>
    </div>
  );
}

export default ContentSubmission;
